import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import OrdersDispatchDetail from './components/OrdersDispatchDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageOrdersDispatch',
  components: {
    OrdersDispatchDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;